import { SelectOption, SelectOptionsCollection } from 'shared/models/SelectOption';
import { ERentDurationUnit } from 'shared/repositories/coworking/entities/api/V1BookCoworkingRequestSchema';

export const rentDurationUnitSelectOptions: SelectOptionsCollection<ERentDurationUnit> = [
  new SelectOption('мес.', ERentDurationUnit.Month),
  new SelectOption('дней', ERentDurationUnit.Day),
];
